<style lang='less' scoped>
@import '../base.less';
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.moduleName' :placeholder="$t('模块名称') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isAd' clearable
                                                      :placeholder="$t('模块类型') " style='width:120px'>
              <Option :value="0">{{ $t('玩法模块') }}</Option>
              <Option :value="1">{{ $t('文字广告') }}</Option>
              <Option :value="2">{{ $t('图片广告') }}</Option>
              <Option :value="3">{{ $t('帖子高手榜(广告部分)') }}</Option>
              <Option :value="4">{{ $t('自定义模块') }}</Option>
              <Option :value="5">{{ $t('帖子详情页模块') }}</Option>
            </Select>
            </FormItem>


            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row> <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'Lhc/authorUpdateOrCreate'" @click='preAdd' icon='md-add'>{{
                $t('新增自定义模块')
              }}
            </Button>

            <Button type='primary'  @click='preAddPlay' icon='md-add'>{{
                $t('新增玩法模块')
              }}
            </Button>

          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='模块类型' prop='isAd'>
          <Select clearable v-model='windowAddItem.isAd' :disabled="windowAddItem.id>=0" style='width:200px'>
            <Option :value="0">{{ $t('玩法模块') }}</Option>
            <Option :value="1">{{ $t('文字广告') }}</Option>
            <Option :value="2">{{ $t('图片广告') }}</Option>
            <Option :value="3">{{ $t('帖子高手榜(广告部分)') }}</Option>
            <Option :value="4">{{ $t('自定义模块') }}</Option>
            <Option :value="5">{{ $t('帖子详情页模块') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='模块名称' prop='moduleName'>
          <Input clearable v-model='windowAddItem.moduleName' :placeholder="$t('请输入模块名称')"
                 :disabled="windowAddItem.isAd==1||windowAddItem.isAd==3||windowAddItem.isAd==5||windowAddItem.isAd==6
                ||windowAddItem.isAd==7||windowAddItem.isAd==8||windowAddItem.isAd==9"></Input>
        </FormItem>
        <!--        如果是开奖模块-->
        <FormItem label='最多几期数据' prop='maxIssues' v-if="windowAddItem.isAd==0">
          <Input clearable v-model='windowAddItem.maxIssues' :placeholder="$t('请输入最多几期数据')"></Input>
        </FormItem>

        <!--        如果是开奖模块-->
        <FormItem label='正序/倒序' prop='moduleSortType' v-if="windowAddItem.isAd==0">
          <Select clearable v-model='windowAddItem.moduleSortType'
                  :placeholder="$t('正序/倒序') " style='width:120px'>
            <Option :value="0">{{ $t('正序') }}</Option>
            <Option :value="1">{{ $t('倒序') }}</Option>
                   </Select>
        </FormItem>

        <FormItem label='新澳门数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_0">
            <Tag color="error">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                      :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>
        <FormItem label='新澳门加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_0" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='香港数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_1">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>

        <FormItem label='香港加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_1" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='老澳门数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_2">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>
        <FormItem label='老澳门加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_2" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='新加坡数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_3">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>
        <FormItem label='新加坡加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_3" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='柬埔寨数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_4">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>

        <FormItem label='柬埔寨加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_4" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='台湾数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_5">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>

        <FormItem label='台湾加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_5" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='印尼数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_6">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>

        <FormItem label='印尼加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_6" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <FormItem label='马来西亚数据' v-if="windowAddItem.isAd==0">
          <p :prop="key" v-for="(value, key) in windowAddItem.fieldData_7">
            <Tag color="success">{{ value[0]['issue'] + '期' }}</Tag>
            <FormItem :label="v2['playName']" v-for="(v2, k2) in value">
              <Input v-model="v2['code']" :placeholder="$t('购买号码')" style="width: 200px;"></Input>
              <span style="margin-left: 15px ;color: red">{{ '开' + v2['open'] }}</span>
              <span v-if="v2['isZhun']=='准'"
                    style="margin-left: 15px ;color: blue">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='错'"
                    style="margin-left: 15px ;color: red">{{ v2['isZhun'] }}</span>
              <span v-if="v2['isZhun']=='未'"
                    style="margin-left: 15px ;color: green">{{ v2['isZhun'] }}</span>
              <Select  clearable v-model="v2['isShow']"
                       :placeholder="$t('显示/不显示') "     style="width:120px;margin-left: 15px ;color: green">
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0" >{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>
          </p>
        </FormItem>
        <FormItem label='马来西亚加粉贴内容(不设置请留空)' v-if="windowAddItem.isAd==0">
          <Input v-model="windowAddItem.jiafen_7" :placeholder="$t('最新一期的预测改成显示加粉内容,一旦开奖，最新一期预测改为必中')"
                 style="width: 500px;"></Input>
        </FormItem>

        <!--    如果是自定义的内容-->
        <FormItem label='自定义内容(最新期号可用 $issue 替代 )' prop='content' v-if="windowAddItem.isAd==4">
          <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{
              $t('编辑源码')
            }}
          </Button>
          <p> (编辑器只适合编辑纯文字，含代码的不要使用编辑器,否则代码会被编辑器过滤掉)</p>

          <div v-if="isHtml==false" style="border: 1px solid #ccc;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="windowAddItem.content"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
            />
          </div>
          <textarea v-if="isHtml==true" v-model="windowAddItem.content" name="ckeditor" rows="10" cols="80"></textarea>
        </FormItem>
        <!--如果是广告模块-->
        <span  v-if="windowAddItem.isAd==10" style="color: red">{{ $t('(此设置即可配置漂浮控件的下载地址,同时APP的接口和内嵌页面也是这里配置,APP需要手动生成,所以需要联系技术生成对应的APP)') }}</span><br>
        <span  v-if="windowAddItem.isAd==10" style="color: red">{{ $t('(安卓接口生成地址:/public/appApi/androidApi.json') }}</span><br>
        <span  v-if="windowAddItem.isAd==10" style="color: red">{{ $t('(苹果网页生成地址:/public/appApi/iosJump.html') }}</span><br>
        <span  v-if="windowAddItem.isAd==10" style="color: red">{{ $t('APP使用的域名解析到/public/appApi 目录下就可以') }}</span>
        <p :prop="key" v-for="(value, key) in windowAddItem.varsData"
           v-if="windowAddItem.isAd==1||windowAddItem.isAd==2||windowAddItem.isAd==3||windowAddItem.isAd==8||windowAddItem.isAd==9||windowAddItem.isAd==10">

          <FormItem :label="value['name']">

            <FormItem label="是否显示" v-if="windowAddItem.isAd==3">
              <i-switch v-model="value['isOpen']"
                        :true-value=1 :false-value=0 true-color="#13ce66" />
            </FormItem>

            <FormItem label="游戏类型" v-if="windowAddItem.isAd==5||windowAddItem.isAd==2||windowAddItem.isAd==3">
              <Select clearable v-model='value["isXg"]'
                      :placeholder="$t('港澳') " style='width:120px'>
                <Option :value="-1">{{ $t('通用') }}</Option>
                <Option :value="0">{{ $t('新澳门') }}</Option>
                <Option :value="1">{{ $t('香港') }}</Option>
                <Option :value="2">{{ $t('老澳门') }}</Option>
                <Option :value="3" >{{ $t('新加坡') }}</Option>
                <Option :value="4" >{{ $t('柬埔寨') }}</Option>
                <Option :value="5" >{{ $t('台湾') }}</Option>
                <Option :value="6" >{{ $t('印尼') }}</Option>
                <Option :value="7" >{{ $t('马来西亚') }}</Option>
              </Select>
              <Button type="primary" v-if="windowAddItem.isAd==2" @click="upPic(key)" >{{ $t('上移') }}</Button>
              <Button type="primary" v-if="windowAddItem.isAd==2" @click="downPic(key)" >{{ $t('下移') }}</Button>
              <Button type="error" v-if="windowAddItem.isAd==2" @click="delPicById(key)" >{{ $t('删除') }}</Button>
            </FormItem>

            <FormItem label="广告位置" v-if="windowAddItem.isAd==3">
              <Input v-model="value['position']" :placeholder="$t('广告位置')" style="width: 200px;"></Input>
            </FormItem>
            <FormItem label="内容" v-if="windowAddItem.isAd!=2&&!value['isHtml']&&!value['isImg']&&!value['isFile']">
              <Input v-if="" v-model="value['content']" :placeholder="$t('内容')" style="width: 450px;"></Input>
            </FormItem>
            <FormItem style="margin-bottom:4px" label='内容' prop='body' v-if="windowAddItem.isAd!=2&&value['isHtml']">
              <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{
                  $t('编辑源码')
                }}
              </Button>

        <div v-if="isHtml==false" style="border: 1px solid #ccc;">
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="height: 200px; overflow-y: hidden;"
            v-model="value['content']"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
          />
        </div>
        <textarea v-if="isHtml==true" v-model="value['content']" name="ckeditor" rows="10" cols="80"></textarea>
        <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>
            <FormItem label="图片高度" v-if="windowAddItem.isAd==2">
              <Input v-model="value['height']" :placeholder="$t('图片高度')" style="width: 450px;"></Input>
            </FormItem>

            <FormItem label='(链接)' prop='content' v-if="windowAddItem.isAd==2||value['isImg']||value['isFile']" >
              <Input style="max-width: 450px;max-height: 200px"  clearable v-model="value['content']" :placeholder="$t('请输入图片的链接地址')"></Input>
            </FormItem>

            <FormItem label="上传" v-if="windowAddItem.isAd==2||value['isImg']||value['isFile']">
        <div class="demo-upload-list" v-if="value['content']&&!value['isFile']">
          <img  :src="value['content']" style="max-width: 450px;max-height: 200px">
          <div class="demo-upload-list-cover">
            <Icon type="ios-trash-outline"
                  @click.native="windowAddItem.varsData[key]['content']=''"></Icon>
          </div>
        </div>
        <input v-if="value['content']" v-model="value['content']" type="hidden" name="image">
        <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!value['content']||value['isFile']"
                :format="['jpg','jpeg','png','gif','apk','mobileconfig']" :max-size="5120"
                :on-success="v=>{handleImgSuccess(v,key)}" :on-format-error="handleImgFormatError"
                :on-exceeded-size="handleImgMaxSize" style="display: inline-block;width:58px">
          <div style="width: 58px;height:58px;line-height: 58px">
            <Icon type="md-camera" size="20"></Icon>
          </div>
        </Upload>

        </FormItem>

        <FormItem label="跳转地址" v-if="windowAddItem.id!=61&&windowAddItem.isAd!=10">
          <Input v-model="value['jump']" :placeholder="$t('跳转地址')" style="width: 450px;"></Input>
        </FormItem>
        </FormItem>
        </p>

        <Button type="primary" v-if="windowAddItem.isAd==2" @click="addPic" >{{ $t('增加一列') }}</Button>
        <Button type="primary" v-if="windowAddItem.isAd==2" @click="delPic" >{{ $t('减少一列') }}</Button>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd2.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAdd2Cancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAdd2Item.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAdd2Form" :model="windowAdd2Item" :label-width="80" label-position="left">
        <!--				<FormItem label="选择模板" v-if="windowAdd2Item.template.length>=1">-->
        <!--					<Select v-model="windowAdd2Item.templatePath" style="width:200px">-->
        <!--						<Option v-for="item in windowAdd2Item.template" :value="item.content" :key="item.content">-->
        <!--							{{ item.name }}</Option>-->
        <!--					</Select>-->
        <!--				</FormItem>-->

        <!--如果是广告模块-->
        <p :prop="key" v-for="(value, key) in windowAdd2Item.customerStyle">
          <FormItem :label="value['name']">
            <FormItem label="" v-if="value.type=='switch'">
              <i-Switch id="switch" v-model="value['content']" size="large">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </FormItem>
            <FormItem label="" v-if="value.type=='color'">
              <ColorPicker v-model="value['content']" :placeholder="$t('内容')"/>
            </FormItem>
          </FormItem>
        </p>


      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAdd2Cancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAdd2Submit" :loading="windowAdd2.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd3.show" width="780" :styles="{top: '30px'}" @on-visible-change="windowAdd3Cancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAdd3Item.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAdd3Validate" :model="windowAdd3Item" :label-width="80"
            label-position="left">

        <FormItem label="选择模板" v-if="windowAdd3Item.template.length>=1">
          <Select v-model="windowAdd3Item.templatePath" style="width:200px"
                  @on-change="getTemplateData(windowAdd3Item.templatePath)">
            <Option v-for="item in windowAdd3Item.template" :value="item.content" :key="item.content">
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem label='模板代码' prop='template'>
          <span>(自定义模板请复制其它模板内容来修改)</span>
          <Input :disabled="!windowAdd3Item.isCustom" v-model="windowAdd3Item.templateData" type="textarea" rows="80"
                 cols="88"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAdd3Cancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAdd3Submit" :loading="windowAdd3.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->


    <!-- windowAddEdit -->
    <Modal v-model="windowAddPlay.show" width="780" :styles="{top: '30px'}" @on-visible-change="windowAddPlayCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddPlayItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddPlayValidate" :model="windowAddPlayItem" :label-width="80"
            label-position="left">
        <FormItem label="模块名称" >
          <Input  v-model="windowAddPlayItem.moduleName" :placeholder="$t('模块名称')" style="width: 450px;"></Input>
        </FormItem>

        <FormItem label='选择玩法' prop='field_ids'>
          <Cascader :data="categorySuperParams"  @on-change="selectWf"
                    style='position: absolute; width:200px' filterable clearable/>
        </FormItem>

        <FormItem label="选择模板">
          <Select v-model="windowAddPlayItem.templatePath" style="width:200px">
            <Option v-for="item in windowAddPlayItem.template" :value="item.content" :key="item.content">
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <p>提示： <br>
          1.添加玩法模块后需要点击采集一下，才会生成玩法数据 <br>
          2.模块添加后，需要在模板编辑中改成自定义模板来修改标题 <br>
          3.可以根据模板内的标签，自定义成想要的模板样式，<br>
        </p>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddPlayCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddPlaySubmit" :loading="windowAddPlay.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},
  data() {
    return {
      editor: null,
      categorySuperParams: [],
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...',
        MENU_CONF: {} },
      mode: 'default', // or 'simple',
      isHtml: false,


      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
              1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
                1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [ {
        title: '序号',
        type: 'index',
        width: 40,
        align: 'center'
      },{
        title: '显示排序',
        sortable: true,
        key: 'showOrder',
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.showOrder,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/moduleDataEdit', {id:params.row.id,showOrder:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      }, {
        title: this.$t('模块名称'),
        key: 'moduleName',
        minWidth: 120,
        width: 120,
        align: 'center'
      }, {
        title: this.$t('模块类型'),
        align: 'center',
        width: 99,
        minWidth: 99,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.isAd == 0 ? '#ed4014' : params.row.isAd ==
                1 ? '#19be6b' : params.row.isAd == 2 ? '#c901e0' : params
                  .row.isAd == 3 ? '#fd070d' : params.row.isAd == 4 ?
                  '#2082f5' : '#f8cf2d',
                borderRadius: '11px',
                border: params.row.isAd == 0 ? '1px solid #ed4014' : params.row
                  .isAd == 1 ? '1px solid #19be6b' : params.row.isAd == 2 ?
                  '1px solid #c901e0' : params.row.isAd == 3 ?
                    '1px solid #fd070d' : params.row.isAd == 4 ?
                      '1px solid #2082f5' : '1px solid #f8cf2d',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.isAd == 0 ? this.$t('玩法模块') :
              params.row.isAd == 1 ? this.$t('文字广告') :
                params.row.isAd == 2 ? this.$t('图片广告') :
                  params.row.isAd == 3 ? this.$t('帖子类型') :
                    params.row.isAd == 4 ? this.$t('自定义模块') : this.$t('帖子详情页模块')),

          ])
        }
      },      {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 190,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAddItem, params
                  .row) //浅复制数据params.row 给 vm.windowAddItem

                vm.windowAdd.show = true
                vm.isHtml=true;
              }
            }
          }, this.$t('编辑')), h('Button', {
            props: {
              type: 'info',
              disabled: params.row.isAd != 4&&params.row.isAd != 10 ? false : true,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAdd2Item, params
                  .row) //浅复制数据params.row 给 vm.windowAddItem
                vm.windowAdd2.show = true

              }
            }
          }, this.$t('样式编辑')), h('Button', {
            props: {
              type: 'success',
              disabled: params.row.isAd <= 2 || params.row.isAd == 5||params.row.isAd == 3|| (params.row.isAd >=6&& params.row.isAd <=10)? false : true,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                Object.assign(vm.windowAdd3Item, params
                  .row) //浅复制数据params.row 给 vm.windowAddItem
                vm.windowAdd3Item.templateData = '';
                vm.windowAdd3Item.isCustom = 0;
                vm.getTemplateData(vm.windowAdd3Item.templatePath)
                vm.windowAdd3.show = true
              }
            }
          }, this.$t('模板编辑')), h('Button', {
            props: {
              type: 'error',
              disabled: params.row.isAd != 5 ? false : true,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                customPost('Lhc/moduleYuLan', {
                  id: params.row.id
                }).then(response => {
                  window.open(response.data.data.tempUrl,
                    '_blank')
                })
              }
            }
          }, this.$t('预览效果')),h('Button', {
            props: {
              type: 'error',
              disabled: (params.row.isAd == 0|| params.row.isAd == 3)? false : true,
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                customPost('Lhc/moduleYuLan', {
                  id: params.row.id,
                  isXg: 1
                }).then(response => {
                  window.open(response.data.data.tempUrl,
                    '_blank')
                })
              }
            }
          }, this.$t('预览(香港)')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('Lhc/moduleDataDel', {
                  id: params.row.id
                }).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                disabled: !((params.row.isAd==0&&params.row.id>1000)||(params.row.isAd == 4 && params.row.moduleName != "广告联系")),
               //  : (params.row.isAd==0?(params.row.template.contains('三字平特模板')):true),
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      }, {
        title: this.$t('新澳门预测'),
        align: 'center',
        width: 60,
        minWidth: 60,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.lastResult_0 < 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.lastResult_0 < 0 ? '1px solid #ed4014' :
                  '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.isAd == 0 ? ((params.row.lastResult_0 > 0 ? '连中' :
              '连错') + Math.abs(params.row.lastResult_0) + '次') : '-'),
          ])
        }
      }, {
        title: this.$t('香港预测'),
        align: 'center',
        width: 60,
        minWidth: 60,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.lastResult_1 < 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.lastResult_1 < 0 ? '1px solid #ed4014' :
                  '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.isAd == 0 ? ((params.row.lastResult_1 > 0 ? '连中' :
              '连错') + Math.abs(params.row.lastResult_1) + '次') : '-'),
          ])
        }
      },{
        title: this.$t('老澳门预测'),
        align: 'center',
        width: 60,
        minWidth: 60,
        key: 'status',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.lastResult_2 < 0 ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.lastResult_2 < 0 ? '1px solid #ed4014' :
                  '1px solid #19be6b',
                display: '',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                padding: '3px'
              },
            }, params.row.isAd == 0 ? ((params.row.lastResult_2 > 0 ? '连中' :
              '连错') + Math.abs(params.row.lastResult_2) + '次') : '-'),
          ])
        }
      },
        {
          title: this.$t('新加坡预测'),
          align: 'center',
          width: 60,
          minWidth: 60,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lastResult_3 < 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lastResult_3 < 0 ? '1px solid #ed4014' :
                    '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.isAd == 0 ? ((params.row.lastResult_3 > 0 ? '连中' :
                '连错') + Math.abs(params.row.lastResult_3) + '次') : '-'),
            ])
          }
        },

        {
          title: this.$t('柬埔寨预测'),
          align: 'center',
          width: 60,
          minWidth: 60,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lastResult_4 < 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lastResult_4 < 0 ? '1px solid #ed4014' :
                    '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.isAd == 0 ? ((params.row.lastResult_4 > 0 ? '连中' :
                '连错') + Math.abs(params.row.lastResult_4) + '次') : '-'),
            ])
          }
        },

        {
          title: this.$t('台湾预测'),
          align: 'center',
          width: 60,
          minWidth: 60,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lastResult_5 < 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lastResult_5 < 0 ? '1px solid #ed4014' :
                    '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.isAd == 0 ? ((params.row.lastResult_5 > 0 ? '连中' :
                '连错') + Math.abs(params.row.lastResult_5) + '次') : '-'),
            ])
          }
        },

        {
          title: this.$t('印尼预测'),
          align: 'center',
          width: 60,
          minWidth: 60,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lastResult_6 < 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lastResult_6 < 0 ? '1px solid #ed4014' :
                    '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.isAd == 0 ? ((params.row.lastResult_6 > 0 ? '连中' :
                '连错') + Math.abs(params.row.lastResult_6) + '次') : '-'),
            ])
          }
        },
        {
          title: this.$t('马来预测'),
          align: 'center',
          width: 60,
          minWidth: 60,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.lastResult_7 < 0 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.lastResult_7 < 0 ? '1px solid #ed4014' :
                    '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.isAd == 0 ? ((params.row.lastResult_7 > 0 ? '连中' :
                '连错') + Math.abs(params.row.lastResult_7) + '次') : '-'),
            ])
          }
        },],
      tableData: [], //用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {
        searchTime: [],
      }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      testUrl: '',
      windowAddValidate: { //窗口校验规则
      }, //----------------

      //弹窗--------------
      windowAdd2: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAdd2Item: { //弹窗数据绑定
        id: 0,
        template: []
      },
      windowAdd2Validate: { //窗口校验规则
      }, //----------------
      windowAdd3: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAdd3Item: { //弹窗数据绑定
        isCustom: 0,
        templateData: '',
        id: 0,
        template: []
      },
      windowAdd3Validate: { //窗口校验规则
      },

      /////
      windowAddPlay: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddPlayItem: { //弹窗数据绑定
        isCustom: 0,
        templateData: [],
        id: 0,
        template: []
      },
      windowAddPlayValidate: { //窗口校验规则
      },
      myModuleList:[]
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcOpenLog/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
    // 自定义上传图片
    let that  = this
    that.editorConfig.MENU_CONF['uploadImage'] = {
      server: baseUrl + 'Index/upload',//上传接口地址
      headers: {
        Authorization: 'Bearer ' + getToken()//配置token
      },
      fieldName: 'file',//上传文件名
      customInsert(result, insertFn) {
        // result是返回的json格式
        // 从 result 中找到 url alt href ，然后插图图片
        console.log(result.data)
        insertFn(result.data['showUrl'], result.data['fileName'], result.data['showUrl'])
      }
    }
  },
  mounted() {
    customPost('Lhc/getCategoryOption', {'isAll':1}).then(response => {
      this.categorySuperParams = response.data.data
    }),
    this.getParams()
  }, beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    selectWf(param) {
      this.windowAddPlayItem.field_ids = param[1];
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id = 0;
      vm.windowAddItem.isAd = 4;
      vm.windowAdd.show = true;
      vm.isHtml=true;

      customPost('Lhc/myModuleParam', {}).then(response => {
        this.myModuleList = response.data.data
      });

    },
    preAddPlay(){
      let vm = this
      vm.windowAddPlayItem.id = 0;
      vm.windowAddPlayItem.isAd = 0;
      customPost('Lhc/myModuleParam', {}).then(response => {
        vm.windowAddPlayItem.template = response.data.data
        console.log(vm.myModuleList)
      });
      // vm.windowAddPlayItem.template=[{'name':'三字平特模板','content':'index/default/module/sanzipingte'},
      //   {'name':'买啥都中模板','content':'index/default/module/maishadouzhong'},
      //   {'name':'绝杀三肖模板','content':'index/default/module/jueshasanxiao'}]
      vm.windowAddPlay.show = true
    },
    getTemplateData(path) {
      customPost('Lhc/getModuleFileData', {templatePath: path}).then(response => {
        this.windowAdd3Item.templateData = response.data.data.templateData;
        this.windowAdd3Item.isCustom = response.data.data.isCustom;
      })
    },

    getParams() {
      let vm = this
      customPost('Lhc/urlGet', {}).then(response => {
        vm.testUrl = response.data.data.testUrl
      })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page = vm.tableShow.currentPage
      vm.searchConf.size = vm.tableShow.pageSize
      customPost('Lhc/moduleDataGetList', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({
                            column,
                            key,
                            order
                          }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        // this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    },
    upPic(id){
      if(id==0){
        return;
      }
      let temp=  this.windowAddItem.varsData[id-1]
      this.windowAddItem.varsData[id-1]=this.windowAddItem.varsData[id]
      this.windowAddItem.varsData[id]=temp
      let newWindowAddItem=  {}
      Object.assign(newWindowAddItem,  this.windowAddItem)
      this.windowAddItem=newWindowAddItem
      // console.log(this.windowAddItem.varsData)
    },
    downPic(id){
      if(id>=this.windowAddItem.varsData.length-1){
        return;
      }
      let temp=  this.windowAddItem.varsData[id+1]
      this.windowAddItem.varsData[id+1]=this.windowAddItem.varsData[id]
      this.windowAddItem.varsData[id]=temp
      let newWindowAddItem=  {}
      Object.assign(newWindowAddItem,  this.windowAddItem)
      this.windowAddItem=newWindowAddItem
      // console.log(this.windowAddItem.varsData)
    },
    delPicById(id){
      let count=this.windowAddItem.varsData.length
      this.windowAddItem.varsData.splice(id,1)
      let newWindowAddItem=  {}
      Object.assign(newWindowAddItem,  this.windowAddItem)
      this.windowAddItem=newWindowAddItem
      // console.log(this.windowAddItem.varsData)
    },
    addPic(){
      let count=this.windowAddItem.varsData.length
      let  nowCount= count+1;
      this.windowAddItem.varsData.push({name:"第"+nowCount+"张",content:'',height:'60',jump:'',isXg:-1})

      let newWindowAddItem=  {}
      Object.assign(newWindowAddItem,  this.windowAddItem)
      this.windowAddItem=newWindowAddItem
      // console.log(this.windowAddItem.varsData)
    },
    delPic(){
      let count=this.windowAddItem.varsData.length
      this.windowAddItem.varsData.splice(count-1,1)
      let newWindowAddItem=  {}
      Object.assign(newWindowAddItem,  this.windowAddItem)
      this.windowAddItem=newWindowAddItem
      // console.log(this.windowAddItem.varsData)
    },
    windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true


          console.log(vm.windowAddItem)


          customPost('Lhc/moduleDataEdit', {
            id: vm.windowAddItem.id,
            moduleSortType: vm.windowAddItem.moduleSortType,
            moduleName: vm.windowAddItem.moduleName,
            isAd: vm.windowAddItem.isAd,
            varsData: vm.windowAddItem.varsData,
            fieldData_0: vm.windowAddItem.fieldData_0,
            fieldData_1: vm.windowAddItem.fieldData_1,
            fieldData_2: vm.windowAddItem.fieldData_2,
            fieldData_3: vm.windowAddItem.fieldData_3,
            fieldData_4: vm.windowAddItem.fieldData_4,
            fieldData_5: vm.windowAddItem.fieldData_5,
            fieldData_6: vm.windowAddItem.fieldData_6,
            fieldData_7: vm.windowAddItem.fieldData_7,
            jiafen_0: vm.windowAddItem.jiafen_0,
            jiafen_1: vm.windowAddItem.jiafen_1,
            jiafen_2: vm.windowAddItem.jiafen_2,
            jiafen_3: vm.windowAddItem.jiafen_3,
            jiafen_4: vm.windowAddItem.jiafen_4,
            jiafen_5: vm.windowAddItem.jiafen_5,
            jiafen_6: vm.windowAddItem.jiafen_6,
            jiafen_7: vm.windowAddItem.jiafen_7,
            maxIssues: vm.windowAddItem.maxIssues,
            content: vm.windowAddItem.content
          }).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
          this.windowAdd.show = false
        }
      })
    },
    windowAdd2Cancel(data) {
      if (!data) {
        // this.windowAddItem.id = 0
        this.$refs['windowAdd2Form'].resetFields()
        this.windowAdd2.show = false
        this.windowAdd2.loading = false
        this.windowAdd2.index = 0
      }
    },
    windowAdd2Submit() {
      let vm = this
      vm.$refs['windowAdd2Form'].validate((valid) => {
        if (valid) {
          vm.windowAdd2.loading = true

          console.log(vm.windowAdd2Item)
          customPost('Lhc/moduleDataEditEasy', {
            id: vm.windowAdd2Item.id,
            templatePath: vm.windowAdd2Item.templatePath,
            customerStyle: vm.windowAdd2Item.customerStyle
          }).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAdd2Cancel()
          }).catch(() => {
            vm.windowAdd2.loading = false
          })
          this.windowAdd2.show = false
        }
      })
    },
    handleImgFormatError(file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },

    handleImgSuccess(response, key) {
      console.log(key)
      if (response.code === 1) {
        if (response.data.fileUrl.startsWith('http')) {
          this.windowAddItem.varsData[key]['content'] = response.data.fileUrl
        } else {
          this.windowAddItem.varsData[key]['content'] = response.data.showUrl
        }
        this.$forceUpdate();
        this.$Message.success(response.msg)
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
    windowAdd3Cancel(data) {
      if (!data) {
        // this.windowAddItem.id = 0
        // this.$refs['windowAdd3Form'].resetFields()
        this.windowAdd3.show = false
        this.windowAdd3.loading = false
        this.windowAdd3.index = 0
      }
    },
    windowAdd3Submit() {
      let vm = this
      customPost('Lhc/saveModuleFile', {
        id: vm.windowAdd3Item.id,
        templatePath: vm.windowAdd3Item.templatePath,
        templateData: vm.windowAdd3Item.templateData
      }).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAdd3Cancel()
      }).catch(() => {
        vm.windowAdd3.loading = false
      })
      this.windowAdd3.show = false
    },

    windowAddPlayCancel(data) {
      if (!data) {
         this.windowAddPlayItem.id = 0
        // this.$refs['windowAddPlayForm'].resetFields()
        this.windowAddPlay.show = false
        this.windowAddPlay.loading = false
        this.windowAddPlay.index = 0
      }
    },
    windowAddPlaySubmit() {
      let vm = this
      customPost('Lhc/addModulePlay', {
        // id: vm.windowAddPlayItem.id,
        templatePath: vm.windowAddPlayItem.templatePath,
        moduleName: vm.windowAddPlayItem.moduleName,
        field_ids: vm.windowAddPlayItem.field_ids

      }).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAddPlayCancel()
      }).catch(() => {
        vm.windowAddPlay.loading = false
      })
      this.windowAddPlay.show = false
    },
  }
}
</script>
